import React from 'react';
import PopupSplitLine from '../../TransfersByAgent/components/PopupSplitLine';
import {PopupSplitLinesContextProvider} from '../../TransfersByAgent/contexts/PopupSplitLinesContext';

export function SplitLineColumnFormatter({_id, amount, splitNum}) {
  return !Boolean(splitNum) && (
    <PopupSplitLinesContextProvider amount={amount}>
      <PopupSplitLine receiptLineId={_id}/>
    </PopupSplitLinesContextProvider>
  )
}
